export default {
    namespaced: true,
    state: {
        item: {},
    },
    getters: {
        id(state) {
			return state.item.hasOwnProperty('id') ? state.item.id: null;
		},

        estimates(state) {
			return state.item.hasOwnProperty('estimates') ? state.item.estimates: [];
		},

        parameters(state) {
			let result = [];

			let params = [
				{ code: 'number', name: 'Реєстраційний номер'},
				{ code: 'vin', name: 'VIN-код'},
				{ code: 'category', name: 'Категорія'},
				{ code: 'brand', name: 'Марка'},
				{ code: 'model', name: 'Модель'},
				{ code: 'yearProd', name: 'Рік випуску авто'},
				{ code: 'bodystyle', name: 'Тип кузова'},
				{ code: 'driver', name: 'Тип приводу'},
				{ code: 'gearbox', name: 'Коробка передач'},
				{ code: 'fuel', name: 'Тип палива'},
				{ code: 'engineVolume', name: "Об'єм двигуна"},
				{ code: 'color', name: "Колір"},
				{ code: 'mileage', name: "Пробіг, км"},
			];

            /*
            
			if(this.item?.generation?.name) result.push({name: "Покоління", value: this.item.generation.name})
			if(this.item?.modification?.name) result.push({name: "Модифікація", value: this.item.modification.name})
			if(this.item?.bodystyle?.name) result.push({name: "Тип кузова", value: this.item.bodystyle.name})
			if(this.item?.driver?.name) result.push({name: "Тип приводу", value: this.item.driver.name})
			if(this.item?.fuel?.name) result.push({name: "Тип палива", value: this.item.fuel.name})
			if(this.item?.gearbox?.name) result.push({name: "Коробка передач", value: this.item.gearbox.name})
			if(this.item?.options?.length) {
				const arr = this.item.options.map(object => object.name);
				const value = arr.join(', ')
				result.push({name: "Опції", value: value})
			}
			if(this.item?.color?.name) result.push({name: "Колір", value: this.item.color.name})
			if(this.item?.country?.name) result.push({name: "Країна виробник", value: this.item.country.name})
			if(this.item?.state?.name) result.push({name: "Область", value: this.item.state.name})
			if(this.item?.city?.name) result.push({name: "Місто", value: this.item.city.name})
			if(this.item?.mileageFrom || this.item?.mileageTo) {
				result.push({name: "Пробіг, тис.км", value: (this.item?.mileageFrom ? this.item?.mileageFrom : '...') + ' - ' + (this.item?.mileageTo ? this.item?.mileageTo : '...')})
			}
			if(this.item?.mileage?.length) result.push({name: "Пробіг, тис.км", value: this.item.mileage})
			if(this.item?.engineVolumeFrom || this.item?.engineVolumeTo) {
				result.push({name: "Об'єм двигуна, л.", value: (this.item?.engineVolumeFrom ? this.item?.engineVolumeFrom : '...') + ' - ' + (this.item?.engineVolumeTo ? this.item?.engineVolumeTo : '...')})
			}
			if(this.item?.engineVolume) result.push({name: "Об'єм двигуна", value: this.item.engineVolume})
			
			//Параметри для методики
			if(this.item?.odometer) result.push({name: "Показник одометра, км", value: this.item.odometer})
			if(this.item?.mileageAvgNorm) result.push({name: "Нормативний середньорічний пробіг, км", value: this.item.mileageAvgNorm})
			if(this.item?.avgPriceUAH) result.push({name: "Середня ринкова ціна", value: this.item.avgPriceUAH})
			if(this.item?.marketregion?.name) result.push({name: "Ринок регіону", value: this.item.marketregion?.name})
			if(this.item?.bargain) result.push({name: "Коефіцієнт торгу", value: this.item.bargain})

			
            */
		   
			//console.log('parameters','item', state.item)

			params.forEach(item => {
				if(state.item.hasOwnProperty(item.code)) {
					let value = state.item[item.code]
					if(value) {
						result.push({
							code: item.code,
							name: item.name,
							value: value?.name ? value.name :  value
						})
					}
				}
			})
			
			return result;
		},
    },
}